module.exports = __webpack_public_path__ + "media/images/icons/twotone/snippets-b2ce90c9bd7e215ff27749e5798b7fd1.svg";